<template>
    <div class="ContentPage">
        <div class="ContentPage-Dots">
            <img src="/img/global/dots.svg" alt="points image"/>
        </div>
        <div class="ContentPage-Container">
            <div class="ContentPage-Content" v-for="(content, index) in this.content" :key="index">
                <Title type="medium" v-if="content.title">
                    {{ content.title }}
                </Title>
              <Spacer></Spacer>
                <div class="Text Justify" v-for="(text, index) in content.text" :key="index" v-html="text"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'HeadPage',
  props: ['content']
}
</script>

<style scoped>
/* 
*   Global
*/
.ContentPage {
    padding: 80px 0;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
}

.ContentPage-Container {
    width: 40%;
}

/*
*   Dots
*/
.ContentPage-Dots {
    margin-right: 45px;
}

.ContentPage-Dots img {
    width: 60px;
}

/* 
* Responsive 
*/
@media (max-width: 880px) {
    /* 
    *   Global
    */
    .ContentPage {
        padding: 40px 0;
    }

    .ContentPage-Container {
        width: 80%;
        text-align: center;
    }

    /*
    *   Dots
    */
    .ContentPage-Dots {
        display: none;
    }
}
</style>